import { Footer } from 'components/Footer'
import { Header } from 'components/Header'
import { Layout } from 'components/Layout'
import { useState, useEffect, useRef } from 'react'
import { OurStoryRoot } from './OurStory.styles'
import { Hero } from './components/Hero/Hero'
import { CompanyFounded } from './components/CompanyFounded/CompanyFounded'
import { DogLovers } from './components/DogLovers/DogLovers'
import { QualityObsession } from './components/QualityObsession/QualityObsession'
import { History } from './components/History/History'
import { FooterCta } from './components/FooterCta/FooterCta'

export const OurStory = () => {
  const isDesktopRef = useRef(false)

  const [, setUpdate] = useState(0) // Dummy state to force re-render

  useEffect(() => {
    const updateMedia = () => {
      isDesktopRef.current = window.matchMedia('(min-width: 900px)').matches
      setUpdate((prev) => prev + 1) // Force re-render to apply the change
    }

    window.addEventListener('resize', updateMedia)
    updateMedia()

    return () => window.removeEventListener('resize', updateMedia)
  }, [])

  const header = <Header />
  return (
    <Layout header={header}>
      <OurStoryRoot>
        <Hero />
        <CompanyFounded isDesktop={isDesktopRef.current} />
        <DogLovers isDesktop={isDesktopRef.current} />
        <QualityObsession isDesktop={isDesktopRef.current} />
        <History isDesktop={isDesktopRef.current} />
        <FooterCta />
        <Footer />
      </OurStoryRoot>
    </Layout>
  )
}
